import { Component, input } from "@angular/core";

@Component({
  selector: "themed-section",
  imports: [],
  templateUrl: "./themed-section.html",
})
export class ThemedSection {
  bgClass = input.required<string>();
}
